import { render, staticRenderFns } from "./deploy-action.vue?vue&type=template&id=015ba5b0&"
import script from "./deploy-action.vue?vue&type=script&lang=js&"
export * from "./deploy-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports